import React from "react";
import ClientInformationPage from "./ClientInformationPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface ClientInformationPageContainerProps extends RouteProps, withValidUserRoleProps {}

const ClientInformationPageContainer = (props: ClientInformationPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <ClientInformationPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(ClientInformationPageContainer);
